import { AfterViewInit, Component, ElementRef, NgZone, OnDestroy } from "@angular/core";

import { TranslateService } from "@ngx-translate/core";
import { BfxMouseModifierKeyService } from "app/bfx-common/services/bfx-mouse-modifier-key.service";
import { SystemConfigPromiseService } from "shared/cubiq-services";
import { BfxBaseBlotterColumnSelectorService } from "../../bfx-base-blotter/bfx-base-blotter-columnselector.service";
// import { LoggerService } from "@bfx/logger";
// const logger = LoggerService.for(__dirname);

import { BfxFwdRollBaseBlotterComponent } from "app/bfx-blotter-intervention/fwd-roll-pricing/bfx-fwd-roll-base-blotter";
import { FwdRollDealtPairTableDefinitionFactory } from "shared/cubiq-services/model/FwdRollDealtPairTableDefinitionFactory";
import { FwdRollRowType } from "shared/cubiq-model-multi-asset";

@Component({
  selector: "bfx-fwd-roll-dealt-pairs-grid",
  templateUrl: "./html/bfx-fwd-roll-orders-grid.html",
  standalone: false,
})
export class BfxFwdRollDealtPairsBlotterComponent
  extends BfxFwdRollBaseBlotterComponent
  implements OnDestroy, AfterViewInit
{
  constructor(
    BfxBlotterElement: ElementRef,
    _tableDefinitionFactory: FwdRollDealtPairTableDefinitionFactory,
    translationService: TranslateService,
    columnSelectorService: BfxBaseBlotterColumnSelectorService,
    sysConfigService: SystemConfigPromiseService,
    mouseModifierKeyService: BfxMouseModifierKeyService,
    zone: NgZone,
  ) {
    super(
      BfxBlotterElement,
      _tableDefinitionFactory,
      translationService,
      columnSelectorService,
      sysConfigService,
      mouseModifierKeyService,
      zone,
    );
  }

  /**
   * Datamodel is taken from the portfoliomodel dealtPairsData
   * @returns
   */
  protected override getGridDataModel() {
    return this.portfolioModel.dealtPairsData;
  }

  public override getRowType(): FwdRollRowType {
    return FwdRollRowType.DEALT;
  }
}
